import { APICore } from './apiCore'

const api = new APICore()

function getIdeas (params) {
  const baseUrl = '/writesonic/ideas'
  return api.create(baseUrl, params)
}

function getIntro (params) {
  const baseUrl = '/writesonic/intro'
  return api.create(baseUrl, params)
}

function getOutlines (params) {
  const baseUrl = '/writesonic/outlines'
  return api.create(baseUrl, params)
}

function writeArticle (params) {
  const baseUrl = '/writesonic/article'
  return api.create(baseUrl, params)
}

function expandText (params) {
  const baseUrl = '/writesonic/expand-text'
  return api.create(baseUrl, params)
}

function instantWriter (params) {
  const baseUrl = '/writesonic/instant-writer'
  return api.create(baseUrl, params)
}

function writeParagraph (params) {
  const baseUrl = '/writesonic/paragraph'
  return api.create(baseUrl, params)
}

function generateImage (params) {
  const baseUrl = '/writesonic/image'
  return api.create(baseUrl, params)
}

export { getIdeas, getIntro, getOutlines, writeArticle, expandText, instantWriter, writeParagraph, generateImage }
